import MasterLayout from "@/layouts/master";

export default [
	{
    path: "/basico",
    component: MasterLayout,
    children: [
      {
        path: "basico",
        name: "basico/basico.basico",
        component: () => import("@/views/basico/basico/index.vue")
      },
    ]
  }
]